export const errors: Map<string, string> = new Map([
  ['User_Not_Valid', "L'utilisateur n'est pas valide."],
  ['Login_Not_Valid', "L'identifiant de l'utilisateur n'est pas valide."],
  ['Id_Not_Valid', "L'id de l'utilisateur n'est pas valide."],
  ['Email_Not_Valid', "Le mail de l'utilisateur n'est pas valide."],
  ['Phone_Not_Valid', "Le téléphone de l'utilisateur n'est pas valide."],
  [
    'Code_Validation_Not_Valid',
    "Le code de validation de l'utilisateur n'est pas valide.",
  ],
  [
    'Code_Validation_Already_Validated',
    "Le code de validation de l'utilisateur a déjà été validé.",
  ],
  ['Organisme_Not_Valid', "L'organisme n'est pas valide."],
  ['Id_Organisme_Not_Valid', "L'id de l'organisme n'est pas valide."],
  ['Crpcen_Organisme_Not_Valid', "Le crpcen de l'organisme n'est pas valide."],
  ['User_Already_Used', 'Un utilisateur avec cet identifiant existe déjà.'],
  [
    'Email_Already_Used',
    'Un utilisateur avec ce mail existe déjà, veuillez saisir un mail différent.',
  ],
  ['User_To_Create_Not_Valid', "L'utilisateur a créer n'est pas valide."],
  [
    'User_To_Create_Lastname_Not_Valid',
    "Le nom de l'utilisateur a créer n'est pas valide.",
  ],
  [
    'User_To_Create_Firstname_Not_Valid',
    "Le prenom de l'utilisateur a créer n'est pas valide.",
  ],
  [
    'User_To_Create_Email_Not_Valid',
    "Le mail de l'utilisateur a créer n'est pas valide.",
  ],
  [
    'User_To_Create_Email_Already_Exist',
    "Le mail de l'utilisateur a créer existe déjà.",
  ],
  ['User_To_Validate_Not_Valid', "L'utilisateur a valider n'est pas valide."],
  [
    'User_To_Validate_Login_Not_Valid',
    "Le login de l'utilisateur à valider n'est pas valide.",
  ],
  [
    'User_To_Validate_CodeValidation_Not_Valid',
    "Le code de validation de l'utilisateur à valider n'est pas valide.",
  ],
  [
    'User_Cant_Create_User',
    "L'utilisateur' n'a pas les droits pour créer un utilisateur.",
  ],
  [
    'User_Cant_Update_User',
    "L'utilisateur' n'a pas les droits pour mettre à jour cet utilisateur.",
  ],
  [
    'User_Cant_Access_User',
    "L'utilisateur' n'a pas les droits pour accéder à cet utilisateur.",
  ],
  [
    'DEFAULT',
    "Une erreur s'est produite, veuillez contacter votre administrateur.",
  ],
  ['START_DATE_MIN', 'La date de début ne doit pas être antérieure à 1 an'],
  [
    'END_DATE_BEFORE_START_DATE',
    'La date de fin ne peut être antérieure à la date de début',
  ],
  [
    'START_DATE_AFTER_TODAY',
    "La date de début ne peut pas être postérieure à la date d'aujourd'hui.",
  ],
  [
    'END_DATE_AFTER_START_DATE_MAX',
    "L'intervalle sélectionné ne peut excéder 3 mois",
  ],
  ['USER.LOGIN.NOT_EMPTY', 'Veuillez entrer un login'],
  ['USER.LOGIN.MAX_LENGTH', 'Le login ne doit pas dépasser 100 caractères'],
  [
    'USER.LOGIN.INVALID_FORMAT',
    'Le login ne doit contenir que des lettres minuscules, des chiffres, et les symboles . (point), - (tiret), _ (underscore)',
  ],
  [
    'USER.LOGIN.ALREADY_EXISTS',
    'Ce login est déjà utilisé. Veuillez en choisir un autre',
  ],
  ['USER.FIRSTNAME.MAX_LENGTH', 'Le prénom ne doit pas dépasser 50 caractères'],
  ['USER.LASTNAME.MAX_LENGTH', 'Le nom ne doit pas dépasser 100 caractères'],
  [
    'USER.EMAIL.MAX_LENGTH',
    "L'adresse email ne doit pas dépasser 255 caractères",
  ],
  [
    'USER.EMAIL.INVALID_FORMAT',
    "L'adresse e-mail n’est pas valide. Utilisez un format comme nom@sous.domaine.com",
  ],
  [
    'USER.EMAIL.ALREADY_EXISTS',
    'Cet e-mail est déjà utilisé. Veuillez en utiliser un autre',
  ],
  ['ORGANIZATION.CODE.NOT_EMPTY', 'Veuillez entrer un code pour l’organisme'],
  [
    'ORGANIZATION.CODE.MAX_LENGTH',
    "Le code de l'organisme doit avoir 6 caractères maximum",
  ],
  [
    'ORGANIZATION.CODE.INVALID_FORMAT',
    'Le code ne doit contenir que des lettres majuscules et des chiffres',
  ],
  [
    'ORGANIZATION.CODE.ALREADY_EXISTS',
    "Ce code d'organisme est déjà pris. Veuillez en choisir un autre",
  ],
  [
    'ORGANIZATION.COMPANY_NAME.MAX_LENGTH',
    "Le nom de l'entreprise doit avoir 200 caractères maximum",
  ],
  [
    'ORGANIZATION.LINE_1.MAX_LENGTH',
    "Chaque ligne d'adresse ne doit pas dépasser 38 caractères",
  ],
  [
    'ORGANIZATION.LINE_2.MAX_LENGTH',
    "Chaque ligne d'adresse ne doit pas dépasser 38 caractères",
  ],
  [
    'ORGANIZATION.LINE_3.MAX_LENGTH',
    "Chaque ligne d'adresse ne doit pas dépasser 38 caractères",
  ],
  [
    'ORGANIZATION.CITY.MAX_LENGTH',
    'La ville ne doit pas dépasser 50 caractères',
  ],
  [
    'ORGANIZATION.POSTAL_CODE.MAX_LENGTH',
    'Le code postal ne doit pas dépasser 5 chiffres',
  ],
  [
    'ORGANIZATION.POSTAL_CODE.INVALID_FORMAT',
    'Le code postal ne doit contenir que des chiffres',
  ],
  [
    'ORGANIZATION.EMAIL.MAX_LENGTH',
    "L'adresse e-mail ne doit pas dépasser 255 caractères",
  ],
  [
    'ORGANIZATION.EMAIL.INVALID_FORMAT',
    "L'adresse e-mail n’est pas valide. Utilisez un format comme nom@sous.domaine.com",
  ],
  [
    'ORGANIZATION.PHONE.INVALID_FORMAT',
    'Le numéro de téléphone doit être composé de 10 chiffres (exemple : 0123456789)',
  ],
  ['ORDER.OFFER_ID.NOT_AN_UUIDV4', "L'id de l'offre n'est pas un uuid v4"],
  ['ORDER.OFFER_ID.INVALID_FORMAT', "L'id de l'offre n'est pas valide"],
  ['ORDER.OFFER_ID.NOT_EXISTING', "L'offre n'existe pas"],
  ['SIRET.NOT_FOUND', 'SIRET introuvable. Veuillez vérifier votre saisie'],
  ['SIRET.BAD_GATEWAY', 'Impossible de vérifier le SIRET. Veuillez réessayer.'],
]);
